import React, { useContext, useState } from 'react'
import { Context } from '../../context/Context';
import Topbar from '../../components/topbar/Topbar';
import "./home.css"
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/userRedux';

const Home = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.currentUser);
  const [changeHamber, setChangeHamber] = useState(false);
  const handleLogout = () => {
    dispatch(logout());
    window.location.reload();
  }
  return (
    <>
      <div className="navbarhead">
        <div className="outer-container">
          <div className="top-bar">
            <h3>Product<span className="header-bold text-primary logo">Drive</span></h3>
            <ul className={`top-menu ${changeHamber ? 'top-mobile' : ''}`}>
              {/* <li><a href="/">Offers</a> </li> */}
              <li><a href="/">Home</a> </li>
              {/* <li><a href="/">Pricing</a> </li> */}
              {/* <li><a href="/">Charges</a> </li> */}
              {!user &&
                <>
                  <li><a className="btn text-primary" href="/register">Onboard</a> </li>
                  <li><a className="btn" href="/login">Login</a> </li>
                </>
              }
              {user &&
                <>
                  <li><a href="/dashboard">Dashboard</a> </li>
                  <li onClick={handleLogout}><a href="#">Logout</a> </li>
                </>
              }

            </ul>
            <i className='hamber mdi mdi-menu' style={{ marginLeft: "20px" }} onClick={() => setChangeHamber(!changeHamber)}></i>
          </div>
        </div>
      </div>
      <div className="constrain">
        <div className="outer-container" style={{ marginTop: "70px" }}>
          <div className="hero-text-space" style={{ marginTop: "40px" }}> </div>
          <div className="content-section-container text-centered bp-100 hero-section">
            {/* <img src="https://i.pinimg.com/originals/a7/4f/41/a74f410ef5d5eea8af546c0641d63290.png" /> */}
            {/* <img src="https://thumbs.dreamstime.com/b/dashboard-design-vector-illustration-concept-management-manage-your-web-site-template-app-de-development-mobile-ui-ux-199943715.jpg" /> */}
            <img src="https://baryon.be/wp-content/uploads/2020/05/3528471-01.jpg" />

            <div className="hero-text">
              <h1><span className="header-bold">Delivery and Payment Management from one Place </span></h1>
              <p>A solution to help manage orders and make customers engagement during the waiting period a fun. We help keep your customers up to date with the progress of their orders </p>
              <a className="btn btn-primary" href="mailto:vegiorder@gmail.com">Contact Us</a>
            </div>
          </div>
          <div className="left-to-right">

            <div className="content-section-container workout-img-2">
              {/* <img src="https://assets.codepen.io/6060109/workout-vector-2.png" /> */}
              {/* <img src="https://i.pinimg.com/originals/a7/4f/41/a74f410ef5d5eea8af546c0641d63290.png" /> */}
              <img src="https://thumbs.dreamstime.com/b/dashboard-design-vector-illustration-concept-management-manage-your-web-site-template-app-de-development-mobile-ui-ux-199943715.jpg" />
            </div>

            <div className="blue-bg">
              <div className="content-section-container">
                <h2>Choose<span className="header-bold"> Customized Settings </span>that make your customers happy</h2>
                <p> User welcome messages, Order status messages or follow up messages in your own tone that your customers are familier with.</p>
                <p>Messages that are suitable for emails and short messaging.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="bp-100" />
        <div className="gradient-blue-bg-cus">
          <div className="content-section-container text-centered tp-80 trainer-text">
            <h2 className="header-bold">Grow Customer Base</h2>
            <h6>Our Mission is</h6>
            <p>to help you grow your customer base up to 20% during the first 4 weeks of onboarding</p>
            <p>to give you tips to help keep your customers happy to come back</p>
            <a className="btn btn-secondary" href="#">Onboard here</a>
          </div>
          {/* <img src="https://www.pngitem.com/pimgs/m/238-2386953_best-facebook-banner-ads-hd-png-download.png" /> */}
          <img src="https://i.pinimg.com/originals/77/12/66/7712662202eaec6176a883c7e30c6daf.gif" />
        </div>
        <div className="bp-100" />
        <div className="outer-container">

          <footer className="content-section-container text-centered ">
            <h3>Product<span className="header-bold"> Drive</span></h3>
            {/* <ul>
              <li>Home</li>
              <li>About Us</li>
              <li>Contact</li>
              <li>Our trainings</li>
              <li>Price</li>
              <li>FAQ</li>
            </ul> */}
            {/* <div className="stay-up-to-date">
              <h6 className="bm-15">Stay up to date</h6>
              <input type="text" placeholder="Your email address" />
            </div> */}
            <div className="footer-icons">
              <div className="icon-circle">
                <img src="https://assets.codepen.io/6060109/icon-instagram.png" />
              </div>
              <div className="icon-circle">
                <img src="https://assets.codepen.io/6060109/icon-dribbble.png" />
              </div>
              <div className="icon-circle">
                <img src="https://assets.codepen.io/6060109/icon-twitter.png" />
              </div>
              <div className="icon-circle">
                <img src="https://assets.codepen.io/6060109/icon-youtube.png" />
              </div>
            </div>
          </footer>

        </div>
      </div>
    </>
  )
}
export default Home;